import AmountAndIntervalSelection from './AmountAndIntervalSelection'

export default AmountAndIntervalSelection
